<template>
  <div class="container">
    <div class="actions">
      <v-button icon="arrow_left" label="terug" :disabled="isFirst" @click="prev"/>
      <v-button v-if="isPaused" icon="play" label="play" @click="resume"/>
      <v-button v-else icon="pause" label="pauze" @click="pause"/>
      <v-button icon="stop" label="stop" @click="stop"/>
      <v-button icon="arrow_right" label="verder" :disabled="isLast" @click="next"/>
    </div>
    <sidebar/>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import AudioPlayer from '@/AudioPlayer'
import Button from '@/components/Button'
import Sidebar from '@/components/Sidebar'
import { defer } from '@/utils'

export default {
  name: 'StoryView',
  components: {
    'v-button': Button,
    Sidebar
  },
  computed: {
    ...mapState({
      isPaused: state => state.paused,
      playerSelected: state => state.player !== null,
      characterSelected: state => state.character !== null,
      story: state => state.data,
      length: state => state.data.content.length,
      isFirst: state => state.data.index === 0,
      isLast: state => state.data.index === state.data.fragments.length - 1,
      audio: state => {
        const { index, fragments } = state.data
        return fragments[index].audio
      }
    })
  },
  methods: {
    ...mapActions([
      'loadScene',
      'updateScene'
    ]),
    prev () {
      this.updateScene({ index: this.story.index - 1 })
      this.isPaused && this.$store.dispatch('resume')
    },
    next () {
      this.updateScene({ index: this.story.index + 1 })
      this.isPaused && this.$store.dispatch('resume')
    },
    pause () {
      AudioPlayer.pause()
      this.$store.dispatch('pause')
    },
    resume () {
      AudioPlayer.play()
      this.$store.dispatch('resume')
    },
    stop () {
      this.onStoryEnded()
      defer(100, () => {
        AudioPlayer.pause()
        if (this.characterSelected) {
          this.loadScene({ name: 'SelectStory' })
        } else if (this.playerSelected) {
          this.loadScene({ name: 'SelectCharacter' })
        } else {
          this.loadScene({ name: 'SelectPlayer' })
        }
      })
    },
    onAudioEnded () {
      this.isLast ? this.stop() : this.next()
    },
    onStoryStarted () {
      this.timeStart = Date.now()
      this.track('start_story', {
        event_category: 'story',
        event_label: this.story.title
      })
    },
    onStoryEnded () {
      this.track('end_story', {
        event_category: 'story',
        event_label: this.story.title,
        value: Date.now() - this.timeStart
      })
    }
  },
  watch: {
    audio: {
      immediate: true,
      handler (audio) {
        AudioPlayer.pause().load(audio)
        defer(1000, () => {
          if (!this.isPaused) AudioPlayer.play()
        })
      }
    }
  },
  created () {
    AudioPlayer.on('ended', this.onAudioEnded)
  },
  mounted () {
    this.onStoryStarted()
  },
  beforeDestroy () {
    AudioPlayer.off('ended', this.onAudioEnded)
  }
}
</script>

<style scoped lang="scss">
.container {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  @include fade-in(400ms, 2s);
}

.actions {
  width: 100%;
  max-width: 26rem;
  display: flex;
  justify-content: space-between;
  margin-bottom: $spacing-md;
}

.sidebar {
  animation: slideIn 400ms 2s;
}

@keyframes slideIn {
  from { transform: translateX(120%); }
}
</style>
